import styled from 'styled-components';

const DropdownWrapper = styled.div`
    ${props => `
        position: absolute;
        background: #FFFFFF;
        border: 1px solid #CACDD4;
        box-shadow: 0px 4px 16px 0px #00000026;
        border-radius: 8px;
        width: 240px;
        right: 0px;
        top: 75px;
        overflow: hidden;
        ${!props.active && `display: none;`}
    `}
`

export default DropdownWrapper;